import React, { Component } from 'react'
import Helmet from 'react-helmet'
import { solr_global_url, solr_search_url } from './../../utils/js/endpoints'

import Sidebar from './Sidebar'
import SearchResultsItem from './SearchResultsItem'
import SearchForm from './SearchForm'
import CustomResultsItem from './CustomResultsItem'
import SearchOption from './SearchOption'
import { getParameterByName } from '../../utils/js/browser_helpers'
import Paginator from '../players/shared/paginator/Paginator'
import { dataFetcher } from '../../utils/js/fetch_helpers'
import { getMonthName } from '../../utils/js/time_helpers'

import './Search.scss'

class Search extends Component {
    state = {
        results: [],
        response: [],
        total: 0,
        page: 1,
        playersTeamsByKeyword: [],
        keyword: '',
        current_keyword: '',
        results_ready: false,
        params: {
            sort: 'date',
            filter: '',
            page: 1,
        },
        isFetching_results: false,
        isError_results: false,
        isFetching_playersTeamsByKeyword: false,
        isError_playersTeamsByKeyword: false,
    }

    searchData = dataFetcher({
        key: 'response',
        name: 'response',
        responsePointer: 'data.response',
    })
    querySearchResults = this.searchData.fire
    cancelSearchResults = this.searchData.cancel

    playersData = dataFetcher({
        key: 'playersTeamsByKeyword',
        name: 'playersTeamsByKeyword',
        responsePointer: 'data.response.docs',
    })
    getplayersTeamsByKeyword = this.playersData.fire
    cancelGetplayersTeamsByKeyword = this.playersData.cancel

    componentDidMount() {
        this.cancelSearchResults()
        this.cancelGetplayersTeamsByKeyword()

        const keyword = getParameterByName('s')
        const page = getParameterByName('page') ? getParameterByName('page') : 1

        if (keyword && keyword.length !== 0) {
            this.setState(
                {
                    keyword: keyword,
                    page: page ? page : 1,
                },
                () => this.doKeywordSearch(keyword, this.state.params)
            )
        }
    }

    onSubmit = (e, keyword) => {
        e.preventDefault()
        this.doKeywordSearch(keyword, this.state.params)
        this.setState({ keyword, current_keyword: keyword })
    }

    onKeywordChange = e => {
        const keyword = e.target.value
        this.setState({
            keyword: keyword,
            page: 1,
        })
    }

    searchCallback = () => {
        const response = this.state.response

        this.setState({
            results: response.docs || [],
            total: response.numFound,
            results_ready: true,
        })
    }

    getSearchResults(keyword, params) {
        let params_query = ''
        let start = 0

        if (params) {
            if (params.sort === 'relevance') {
                params_query += '&sort=score desc'
            }
            if (params.sort === 'date') {
                params_query += '&sort=date desc'
            }
            if (params.filter) {
                params_query += '&fq=type:' + params.filter
            }
            if (params.page && params.page !== 1) {
                start = (params.page - 1) * 10 + 1
            }
        }

        params_query += '&start=' + start

        this.querySearchResults(
            `${solr_global_url}/select?qt=ac&q="${keyword}"${params_query}&wt=json`,
            this.searchCallback
        )
    }

    onSortOptionsChange = (name, value) => {
        const params = this.state.params
        params[name] = value
        params.page = 1

        this.setState(
            {
                params: params,
                page: 1,
            },
            () => this.getSearchResults(this.state.keyword, params)
        )

        this.props.history.push('/search/?s=' + this.state.keyword + '&page=1')
    }

    toggleExpandedClass = e => {
        if (e.target.classList.contains('dropdown-filter')) {
            e.target.classList.toggle('is-expanded')
        } else if (e.target.classList.contains('dropdown-option')) {
            if (e.target.parentElement.getElementsByClassName('is-selected').length !== 0) {
                let active = e.target.parentElement.getElementsByClassName('is-selected')
                active[0].classList.remove('is-selected')
            }

            e.target.classList.add('is-selected')
            e.target.parentElement.classList.toggle('is-expanded')
        } else {
            e.target.parentElement.classList.toggle('is-expanded')
        }

        this.onSortOptionsChange(
            e.target.getAttribute('data-name'),
            e.target.getAttribute('data-value')
        )
    }

    doKeywordSearch(keyword, params) {
        this.getplayersTeamsByKeyword(
            `${solr_search_url}/select?qt=ac&q=${keyword}&wt=json&rows=5000`
        )
        this.getSearchResults(keyword, params)

        this.props.history.push('/search/?s=' + keyword + '&page=' + params.page)
    }

    paginationClick = new_page_number => {
        const params = this.state.params
        params.page = new_page_number

        this.setState(
            {
                page: new_page_number,
            },
            () => this.getSearchResults(this.state.keyword, params)
        )

        this.props.history.push('/search/?s=' + this.state.keyword + '&page=' + new_page_number)
    }

    render() {
        if (
            this.state.playersTeamsByKeyword.length > 0 &&
            !this.state.isFetching_playersTeamsByKeyword
        ) {
            var player_results = this.state.playersTeamsByKeyword
                .filter(item => item.type === 'player')
                .slice(0, 6)
            var team_results = this.state.playersTeamsByKeyword
                .filter(item => item.type === 'team')
                .slice(0, 6)
        }

        return (
            <div className="Search__cont search">
                <Helmet
                    title={
                        this.state.current_keyword
                            ? `You searched for ` + this.state.current_keyword + ` - Sportsnet.ca`
                            : `Search - Sportsnet.ca`
                    }
                    link={[
                        {
                            rel: 'canonical',
                            href: `${window.location.origin}/search`,
                        },
                    ]}
                />
                <div className="inner_cont">
                    <div className="left_col">
                        <h1 className="title">SEARCH RESULTS</h1>
                        <SearchForm
                            onSubmit={this.onSubmit}
                            placeholder={this.state.keyword || 'Enter Search Keyword'}
                        />
                        <div className="search-bar__sort-options">
                            <form name="sort-options" className="search-bar__form-wrap">
                                <SearchOption
                                    type="sort"
                                    handler={this.onSortOptionsChange}
                                    expand={this.toggleExpandedClass}
                                />
                                <SearchOption type="filter" expand={this.toggleExpandedClass} />
                            </form>
                            <div className="search_bar__total">{this.state.total} Results</div>
                        </div>

                        {player_results && player_results.length > 0 && (
                            <CustomResultsItem data={player_results} type="players" />
                        )}

                        {team_results && team_results.length > 0 && (
                            <CustomResultsItem data={team_results} type="teams" />
                        )}

                        {this.state.results_ready && this.state.results.length !== 0 && (
                            <div className="search_results_posts_cont">
                                {this.state.results.map((post, index) => {
                                    const post_date = new Date(post.displaydate)
                                    post.parsed_date =
                                        getMonthName([post_date.getMonth()], false) +
                                        ' ' +
                                        post_date.getDate() +
                                        ', ' +
                                        post_date.getFullYear()

                                    if (post.content && post.content !== ' ') {
                                        post.content = post.content.substring(0, 110) + '[...]'
                                    }

                                    if (
                                        post.post_thumbnail_href_str &&
                                        post.post_thumbnail_href_str[0] &&
                                        post.post_thumbnail_href_str[0] !== 'false'
                                    ) {
                                        post.image = post.post_thumbnail_href_str[0]
                                    }

                                    return (
                                        <SearchResultsItem
                                            data={post}
                                            key={`${index}${post.title}`}
                                        />
                                    )
                                })}
                            </div>
                        )}
                    </div>

                    <div className="right_col hidden-xs hidden-sm hidden-md">
                        <Sidebar />
                    </div>
                    <Paginator
                        rowLength={this.state.total}
                        paginateCallback={this.paginationClick}
                        activePage={this.state.page}
                        pageSize={10}
                    />
                </div>
            </div>
        )
    }
}

export default Search
